/*----- Core -----*/
import React               from 'react'
import ReactGA 						 from 'react-ga'
import ViewsContainer      from './modules/commons/ViewsContainer'
import { ConnectedRouter } from 'connected-react-router'
import { Provider }        from 'react-redux'
import { store, history }  from './store/Store'

/*----- Styles -----*/
import 'antd/dist/antd.css'
import GlobalStyle from './GlobalStyle'

ReactGA.initialize('UA-178419672-1');
ReactGA.pageview(window.location.pathname + window.location.search);

/*----- Export -----*/
export default function App() {
	return (
		<Provider store={store}>
			<ConnectedRouter history={history}>
				<ViewsContainer />
				<GlobalStyle />
			</ConnectedRouter>
		</Provider>
	)
}